import React from 'react'
import PropTypes from 'prop-types'
import { propTypes } from '../../helpers'
import {
  AdminPage,
  DocumentPage,
  ExternalPage,
  StoryPage,
  VisualizationPage
} from '../'

const PageFactory = ({ category, categoryRenderer: CategoryPage }) => {
  switch (category.categoryType) {
    case 'ADMIN':
      return <AdminPage category={category} />
    case 'DOCUMENT':
      return <DocumentPage category={category} />
    case 'EXTERNALMODULE':
      return <ExternalPage category={category} />
    case 'STORY':
      return <StoryPage category={category} />
    case 'VISUALIZATION':
      return <VisualizationPage category={category} />
    default:
      return <CategoryPage category={category} />
  }
}

PageFactory.propTypes = {
  category: propTypes.categoryPropType,
  categoryRenderer: PropTypes.elementType.isRequired
}

export { PageFactory }
